<template>
    <VListGroup v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </VListGroup>
</template>

<script>
const ELEMENT_CLASS = 'sr-list-group';

export default {
    name: 'SrListGroup',
    computed: {
        classList() {
            return [ELEMENT_CLASS];
        },
    },
};
</script>
